import { createContext, useContext, useMemo, useState } from 'react'

const UserSourceDataContext = createContext()
const UserSourceActionsContext = createContext()

const UserSourceProvider = ({ children }) => {
	const [source, setSource] = useState('')

	const actions = useMemo(() => ({ setSource }), [])

	return (
		<UserSourceDataContext.Provider value={source}>
			<UserSourceActionsContext.Provider value={actions}>{children}</UserSourceActionsContext.Provider>
		</UserSourceDataContext.Provider>
	)
}

export default UserSourceProvider

export const useUserSourceData = () => useContext(UserSourceDataContext)
export const useUserSourceActions = () => useContext(UserSourceActionsContext)
